import { Text, Box } from "@chakra-ui/react";
import { transparentize } from "polished";
import { useTheme } from "@emotion/react";
import { Layout } from "@/components/layout";
import { useTranslation, Trans } from "react-i18next";

export default function Dsclaimer() {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const titleStyle = {
    my: 2
  };
  const paragraphStyle = {
    opacity: 0.45,
    textIndent: "2em"
  };

  const url = `/earthquake-early-warning/support-city${window.location.search}`;

  return (
    <Layout>
      <Box p={3} minHeight="100vh">
        <Text textAlign="center" sx={titleStyle}>
          {t("earthquake.dsclaimer.title")}
        </Text>
        <Text sx={paragraphStyle}>
          {t("earthquake.dsclaimer.sub1.content")}
        </Text>
        <Text sx={paragraphStyle}>
          <Trans
            i18nKey="earthquake.dsclaimer.sub2.content"
            components={[<a href={url} style={{ color: "blue" }} key="0" />]}
          />
        </Text>
        <Text sx={paragraphStyle}>
          {t("earthquake.dsclaimer.sub3.content")}
        </Text>
        <Text sx={paragraphStyle}>
          {t("earthquake.dsclaimer.sub4.content")}
        </Text>
        <Text sx={paragraphStyle}>
          {t("earthquake.dsclaimer.sub5.content")}
        </Text>
      </Box>
    </Layout>
  );
}
